// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TaskCenterCardList_wrapper__D0qTG","homeCardsWrapper":"TaskCenterCardList_homeCardsWrapper__KImsR","homeCards":"TaskCenterCardList_homeCards__5I9SP"};